// Build-in
import React, { useState, Suspense } from "react";

// External
import { Tabs, Tab, Tooltip, OverlayTrigger } from "react-bootstrap";

// Internal
import DynamicComponents from "../../helpers/dynamicComponents";

// Styles
import "./index.scss";

export default React.memo((tabProps) => {
  const { content } = tabProps;

  const { _uid } = content[0];

  const DEFAULT_ACTIVE_TAB = _uid;
  const [activeTab, setActiveTab] = useState(DEFAULT_ACTIVE_TAB);

  const Components = DynamicComponents.importedComponents(content);

  const mapPropsToConfig = (tabContent) => {
    const configWithProps = [];
    tabContent.forEach((tab) => {
      if (tab.component) {
        const { component, ...props } = tab;
        configWithProps.push({
          ...props,
          paramsData: tabProps,
          key: tab._uid,
          component: component,
        });
      }
    });
    return configWithProps;
  };

  const renderComponents = (tabs) => {
    return (
      <>
        {
          <Tabs
            activeKey={activeTab}
            onSelect={(key) => setActiveTab(key)}
            className="child-tabs"
          >
            {React.Children.toArray(
              tabs &&
                tabs.map((tab) => {
                  if (typeof Components[tab.component] !== "undefined") {
                    const Component = Components[tab.component];
                    return (
                      <Tab
                        eventKey={tab._uid}
                        title={
                          tab?.toolTip ? (
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip className="custom-tooltip">
                                  {" "}
                                  {tab?.toolTip}{" "}
                                </Tooltip>
                              }
                            >
                              <span>{tab.headline}</span>
                            </OverlayTrigger>
                          ) : (
                            tab.headline
                          )
                        }
                        className="p-0 m-0"
                      >
                        {activeTab === tab._uid && (
                          <Suspense key={tab._uid} fallback={"Loading..."}>
                            <div id={tab._uid}>
                              <Component
                                activeTab={activeTab}
                                key={tab._uid}
                                {...tab}
                              />
                            </div>
                          </Suspense>
                        )}
                      </Tab>
                    );
                  }
                })
            )}
          </Tabs>
        }
      </>
    );
  };
  const configWithProps = mapPropsToConfig(content);
  return renderComponents(configWithProps);
});
